module.exports = __webpack_public_path__ + "static/media/YF83_4.d80e27d6.jpg";